import React from "react";
import { dateFormaterTime, priceDecimal } from "../../utils/utilities";
import { Row, Col, ListGroup } from "react-bootstrap";
import * as Assets from "../../utils/svg_assets";
import ApiUtils from "../../utils/api_utils";

const ReceivedContent = ({ data = [] }) => {
  return (
    <div className="received">
      <Row className="received-list">
        <ListGroup>
          {data.map((d, index) => (
            <ListGroup.Item key={`key-${index}`}>
              <Row>
                <Col xs={2} sm={2} md={2} className="icon-rewards">
                  <img
                    src={
                      d.icon
                        ? ApiUtils.validateImgUrl({ url: d.icon })
                        : Assets.iconReward
                    }
                    alt="img-history"
                  />
                </Col>
                <Col xs={10} sm={10} md={10}>
                  <Row>
                    <Col xs={7} sm={7} md={7} className="list-title">
                      {d.reason.name}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={7} sm={7} md={7} className="transaction-date">
                      {dateFormaterTime(d.created)}
                    </Col>
                    <Col xs={5} sm={5} md={5} className="list-star">
                      <img
                        src={Assets.iconStar}
                        className="img-star"
                        alt="img-star"
                      />{" "}
                      {priceDecimal(d.points)}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </ListGroup.Item>
          ))}
          {data.length === 0 && (
            <ListGroup.Item className="data-not-found">
              <div>Data not found</div>
            </ListGroup.Item>
          )}
        </ListGroup>
      </Row>
    </div>
  );
};

export default ReceivedContent;
